import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Notificacion } from './notificacion.model';
import { SnackService } from '../shared-services/snack.service';
import { SecurityService } from '../security/security.service';
import { BackendService } from '../core/backend.service';

@Injectable()
export class NotificacionResolver implements Resolve<Notificacion> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected securityService: SecurityService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {

        const notificacion = this.backendService.new(Notificacion);
        return notificacion;
      }

      return await this.backendService.get(Notificacion, Notificacion.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/notificaciones']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/notificacion/notificacion.resolver.ts